import { Typography, CircularProgress } from "@mui/material";
import { BillingContext } from "../../../../../context/BillinEntryContext";
import { useContext } from "react";
import AppURL from "../../../../../constants/AppURL";
import useFetchSubData from "../../../../../helpers/useSubFetch";
import { NepNowDateFormat } from "../../../../../constants/DateFormat";
import { formatMoney_2 } from "../../../../../helpers/DateFormat";
import { postDataToTheServer } from "../../../../../helpers/api";
import { useDispatch } from "react-redux";
import { BILLING_REPORT_LIST_VIEW } from "../../../../../store/inventorySlice";

const LedgerListView = () => {
    const nepNow = NepNowDateFormat();
    const dispatch = useDispatch();
    const context = useContext(BillingContext);
    const { values } = context || {};
    const { data, loading, error } = useFetchSubData(AppURL.AccountURL + `account/ledger/data/list/create/view/?fiscal_start=${'2081/04/01'}&date_ne=${nepNow}&member_sn=${values?.member_sn}&sglsn=71`, values?.member_sn);
    if (!context) {
        return <Typography>Error: Billing context is not available</Typography>;
    }

    if (loading) {
        return (
            <div className="flex justify-center items-center h-24">
                <CircularProgress />
            </div>
        );
    }
    if (error) {
        return <Typography color="error">{error}</Typography>;
    }
    return (
        <div className="relative overflow-x-auto rounded-md h-[25vh] bg-white dark:bg-sky-950">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead className="text-[12px] text-gray-500 border-b-2 border-slate-100 dark:border-sky-800 capitalize bg-slate-200 dark:bg-sky-900 dark:text-gray-400">
                    <tr>
                        <th scope="col" align="center" className="px-2 py-0.5 w-4">S.N</th>
                        <th scope="col" className="px-2 py-0.5 w-28">Date</th>
                        <th scope="col" className="px-2 py-0.5">Particulars</th>
                        <th scope="col" className="px-2 py-0.5">Bill No.</th>
                        <th scope="col" className="px-2 py-0.5">Debit Amount</th>
                        <th scope="col" className="px-2 py-0.5">Credit Amount</th>
                        <th scope="col" className="px-2 py-0.5">SubAcBlc</th>
                        <th scope="col" className="px-2 py-0.5">Dr/Cr</th>
                        <th scope="col" className="px-2 py-0.5">Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    {data && Array.isArray(data.results) && data.results.length > 0 ? (
                        data.results.map((item: any, index: number) => (
                            <tr key={index} className="bg-white cursor-pointer text-[12px] border-b-2 border-slate-100 dark:border-sky-800 dark:bg-sky-950">
                                <th scope="row" align="center" className="px-2 py-0.5 font-medium text-gray-700 whitespace-nowrap dark:text-white">
                                    {index + 1}.
                                </th>
                                <td className="px-2 py-0.5">{item.dated}</td>
                                <td className="px-2 py-0.5">{item.particulars}</td>
                                <td className="px-2 py-0.5" onClick={async () => {
                                    const formData = new FormData();
                                    formData.append("date_ne", item.dated);
                                    formData.append("member_sn", item.tmsn);
                                    formData.append("bill_no", item.billrno);
                                    await postDataToTheServer(AppURL.AccountURL + 'account/billing/reprint/create/list/view/', formData).then((res) => {
                                        dispatch(BILLING_REPORT_LIST_VIEW(res));
                                    });
                                }}>{item.billrno}</td>
                                <td className="px-2 py-0.5">{formatMoney_2(item.dramt ? item.dramt : 0)}</td>
                                <td className="px-2 py-0.5">{formatMoney_2(item.cramt ? item.cramt : 0)}</td>
                                <td className="px-2 py-0.5">{formatMoney_2(item.subaccbal ? item.subaccbal : 0)}</td>
                                <td className="px-2 py-0.5">{item.subdrcr}</td>
                                <td className="px-2 py-0.5">{item.rem}</td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={9} className="text-center py-2 text-[12px]">
                                No ledger data available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default LedgerListView;
